import * as APP from "@/utils/appRequest";
import * as APIS from "@/utils/apisRequest";

export default {
    async getUserCollaborationApplyState(opt) {
        let res = await APP.post({
            url: "/goapi/user/getUserCollaborationApplyState",
            params: {
                ...opt
            }
        });
        return res;
    },
    async userCollaborationApply(opt) {
        let res = await APP.post({
            url: "/goapi/user/userCollaborationApply",
            params: {
                ...opt
            }
        });
        return res;
    },
    async getUserPhone(opt) {
        let res = await APIS.get({
            url: "/UserHome/info_show_list",
            params: {
                ...opt
            }
        });
        return res;
    },

};
